var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 13",
    style: {
      enableBackground: "new 0 0 14 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB800;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,1.3c0.2-0.5,0.8-0.5,1,0l1.1,3.1c0.1,0.2,0.3,0.3,0.5,0.3L12,4.8c0.5,0,0.7,0.6,0.3,0.9l-2.6,2 C9.6,7.8,9.5,8,9.5,8.2l0.9,3.1c0.1,0.5-0.4,0.8-0.8,0.6L7,10c-0.2-0.1-0.4-0.1-0.6,0l-2.7,1.9c-0.4,0.3-0.9-0.1-0.8-0.6L4,8.2 C4,8,4,7.8,3.8,7.7l-2.6-2C0.8,5.4,1,4.8,1.5,4.8l3.3-0.1c0.2,0,0.4-0.1,0.5-0.3L6.3,1.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteAlt);
export default __webpack_public_path__ + "static/media/favorite-alt.a143a8f756748bb2a91dcbf2e47905e7.svg";
export { ForwardRef as ReactComponent };